import styled from "@emotion/styled";
import { fonts } from "@trustpilot/businessapp-patternlibrary";

export const StyledTopBlock = styled.div(() => ({
  whiteSpace: "nowrap",
}));

export const StyledTitle = styled.div({
  color: "var( --text-subtle)",
  padding: "0 16px 8px",
  fontSize: "10px",
  fontWeight: fonts.weights.bold,
  textTransform: "uppercase",
  letterSpacing: "0.91px",
});

export const StyledPersonDetails = styled.div({
  ...fonts["body-2"],
  fontWeight: "normal",
  display: "flex",
  color: "var(--text-default)",
  alignItems: "center",
  padding: "0 16px",
  paddingBottom: "16px",
  svg: {
    fill: "var(--action-secondary-text)",
    marginRight: 8,
  },
});

export const StyledItem = styled.li({
  listStyleType: "none",
  [":last-of-type"]: {
    paddingBottom: "16px",
  },
});

export const StyledItemText = styled.span({
  ...fonts["body-2"],
  fontWeight: "normal",
  flex: 1,
});

export const StyledAccountManagerText = styled.span({
  ...fonts["body-2"],
  fontWeight: "normal",
  flex: 1,
  paddingLeft: "16px",
  paddingBottom: "16px",
});
